// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7270a63f","977":"84fae52e"}[chunkId] + ".chunk.js";
};